require("!!/home/ubuntu/factbox-new/factbox/client/node_modules/script-loader/addScript.js")(require("!!/home/ubuntu/factbox-new/factbox/client/node_modules/raw-loader/index.js!/home/ubuntu/factbox-new/factbox/client/node_modules/trix/dist/trix.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/trix/dist/trix.js
// module id = 889
// module chunks = 3